export const URLS: Record<ImportMeta['env']['VITE_APP_ENV'], string> = {
    DEV: 'https://dev.api.dziennik.elfedu.pl',
    UAT: 'https://uat.api.dziennik.elfedu.pl',
    PROD: 'https://api.dziennik.elfedu.pl',
};
